import { useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';

import { Button } from 'ui-components/components/button';
import { FlexColumn, FlexRow, Gap } from 'ui-components/components/flex';
import { Text } from 'ui-components/components/text';

import { ReadOnlyShipTo } from '../../../fulfillment-plan/sections/shipment-details/address/read-only-shipto';
import { EditAddressModal } from './edit-address-modal';
import { useReturnConfig } from '../../return-config-provider';
import { useModal } from '../../../../../hooks/use-modal';

import { messages } from './messages';
import style from './styles.module.less';

export function CustomerAddress({ isEditable = false }) {
  const { shipFrom, resetFormState } = useReturnConfig();

  const { open, close, isOpen } = useModal();

  const { address, recipientInfo } = useMemo(() => {
    const name = get(shipFrom, 'name', '');
    const firstName = get(shipFrom, 'firstName', '');
    const lastName = get(shipFrom, 'lastName', '');
    const email = get(shipFrom, 'email', '');
    const phone = get(shipFrom, 'phone', '');
    const state = get(shipFrom, 'state', '');
    const provinceCode = get(shipFrom, 'provinceCode', '');
    const customerName = name || [firstName, lastName].filter(Boolean).join(' ');

    return {
      recipientInfo: {
        name: customerName,
        email,
        phone,
      },
      address: {
        ...shipFrom,
        name: customerName,
        state: state || provinceCode,
      },
    };
  }, [shipFrom]);

  const onEditButtonClick = useCallback(() => {
    resetFormState();
    open();
  }, [open, resetFormState]);

  return (
    <FlexColumn>
      <FlexRow gap={Gap.Space8}>
        <Text textType='Label' value={messages.addressTitle} />
        {isEditable && (
          <Button className={style.button} onClick={onEditButtonClick} theme='link'>
            <FormattedMessage {...messages.addressEditButtonText} />
          </Button>
        )}
      </FlexRow>
      <ReadOnlyShipTo recipientInfo={recipientInfo} shipTo={address} />
      {isOpen && <EditAddressModal onClose={close} />}
    </FlexColumn>
  );
}
